import config from 'SRC/config/config.json'

export const globalOptions = config.globalOptions
